import { Col } from "antd";
import React, { useEffect } from "react";
import { InputField, ReactSelectField } from "../../../../../atoms/FormElement";
import { useFormContext } from "react-hook-form";
import { SelectOption } from "../../../../../../types/select";
import { InputNumberFieldV2 as InputNumberField } from "../../../../../atoms/FormElement/InputNumberField";

type LessorBankDetailsProps = {
  noEdit?: boolean;
  bankList?: SelectOption[];
  propertyDetails?: any;
};

export const LessorBankDetails = (props: LessorBankDetailsProps) => {
  const { noEdit, bankList, propertyDetails } = props;

  const { control, setValue } = useFormContext();

  const lessorBeneficiary = propertyDetails?.lessorData?.beneficiary;

  useEffect(() => {
    if (!lessorBeneficiary) return;

    setValue("lessor.beneficiary.accountTitle", lessorBeneficiary.accountTitle);
    setValue("lessor.beneficiary.accountNo", lessorBeneficiary.accountNo);
    setValue("lessor.beneficiary.ibanNo", lessorBeneficiary.ibanNo);
  }, [lessorBeneficiary, setValue]);

  useEffect(() => {
    if (!bankList?.length || !lessorBeneficiary?.bankName) return;

    const selectedBank = bankList.find(
      (bank) => bank.label === lessorBeneficiary.bankName || bank.value === lessorBeneficiary.bankName,
    );
    if (!selectedBank) return;

    setValue("lessor.beneficiary.bankName", selectedBank);
  }, [bankList, lessorBeneficiary?.bankName, setValue]);

  return (
    <>
      <Col span={6}>
        <ReactSelectField
          label="Bank"
          fieldname="lessor.beneficiary.bankName"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          iProps={{
            placeholder: "Select Bank",
            isDisabled: noEdit,
            className: `${noEdit ? "disablerselect" : ""}`,
            menuPlacement: "top",
          }}
          selectOption={bankList}
        />
      </Col>
      <Col span={6}>
        <InputField
          label="Account Title"
          fieldname="lessor.beneficiary.accountTitle"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          iProps={{
            placeholder: "Account Title",
            readOnly: noEdit,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
        />
      </Col>
      <Col span={6}>
        <InputNumberField
          label="Account No"
          fieldname="lessor.beneficiary.accountNo"
          control={control}
          inputNumberProps={{
            placeholder: "Account No",
            readOnly: noEdit,
            className: noEdit ? "noEdit" : "",
          }}
        />
      </Col>
      <Col span={6}>
        <InputField
          label="IBAN"
          fieldname="lessor.beneficiary.ibanNo"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          iProps={{
            placeholder: "IBAN",
            readOnly: noEdit,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
        />
      </Col>
    </>
  );
};
